import { create } from 'zustand';
import { logger } from '../utils/logger';

interface BrandingState {
  logoUrl: string | null;
  setLogoUrl: (url: string) => void;
}

export const useBrandingStore = create<BrandingState>((set) => ({
  logoUrl: null,
  setLogoUrl: (url) => {
    logger.info('Updating logo URL', { url });
    set({ logoUrl: url });
  }
}));